import { useSelector } from 'react-redux';
import './DisabledScreen.scss';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { HOME } from '../../constants/routes';
import { t } from '../../i18n/i18n';

const DisabledScreen = ({ tierPlan, children, overlayClassName, modalClassName }) => {
  const history = useHistory();
  const plan = useSelector((state) => state.auth.plan);
  return Number(plan?.tier) === tierPlan ? (
    <div className={`disabled-screen-overlay ${overlayClassName}`}>
      <div className={`disabled-screen-modal ${modalClassName}`}>
        <h5 className="mb-3">{t('DISABLED_SCREEN_TITLE')}</h5>
        <p className="mb-3">{t('DISABLED_SCREEN_DESCRIPTION')}</p>
        <Button
          type="button"
          onClick={() => history.push(HOME)}
          className="bg-blue-dark font-weight-700 text-xs color-white d-flex justify-content-center align-items-center hove"
        >
          {t('DISABLED_SCREEN_BUTTON')}
        </Button>
      </div>
    </div>
  ) : (
    <div>{children}</div>
  );
};

export default DisabledScreen;
